export default "__VITE_ASSET__wUf0XGno__"